module.exports = __webpack_public_path__ + "assets/img/2.79e23c55.jpg";